import React, { useEffect, useState } from "react";
import './ToggleSwitch.css';


const ToggleSwitch = ({ onlabel, offlabel, onClick, checked }) => {

  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    const nextChecked = !isChecked;
    setIsChecked(nextChecked);
    if (onClick) {
      onClick(nextChecked);
    }
  };

  return (
    <button
      type="button"
      className={`toggle-switch-button ${isChecked ? 'toggle-switch-button--checked' : ''}`}
      onClick={handleToggle}
      aria-pressed={isChecked}
    >
      <span className="toggle-switch-button__track">
        <span className="toggle-switch-button__label">
          {isChecked ? onlabel : offlabel}
        </span>
        <span className="toggle-switch-button__thumb" />
      </span>
    </button>
  );
};

export default ToggleSwitch;


